import React from 'react';

interface InputFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helpText?: string;
  icon?: React.ReactNode;
}

export const InputField = React.forwardRef<HTMLInputElement, InputFieldProps>(
  ({ label, error, helpText, icon, className = '', ...props }, ref) => {
    return (
      <div className={`flex flex-col gap-1.5 ${className}`}>
        {label && (
          <label className="text-sm font-medium text-slate-700 dark:text-slate-300">
            {label}
          </label>
        )}
        <div className="relative">
          {icon && (
            <div className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400">
              {icon}
            </div>
          )}
          <input
            ref={ref}
            className={`
              w-full px-4 py-2 bg-white dark:bg-slate-900 border rounded-lg text-sm
              transition-all duration-200 outline-none
              ${icon ? 'pl-10' : ''}
              ${error 
                ? 'border-red-500 focus:ring-4 focus:ring-red-500/10' 
                : 'border-slate-200 dark:border-slate-700 focus:border-primary focus:ring-4 focus:ring-primary/10'
              }
              dark:text-white dark:placeholder-slate-500
            `}
            {...props}
          />
        </div>
        {error ? (
          <p className="text-xs text-red-500 mt-1">{error}</p>
        ) : helpText ? (
          <p className="text-xs text-slate-500 dark:text-slate-400 mt-1">{helpText}</p>
        ) : null}
      </div>
    );
  }
);

InputField.displayName = 'InputField';
